<script lang="ts">
	import type { ContentCarouselBlock } from '$models/Block/ContentCarouselBlock';
	import SliderWrapper from '$components/UI/Slider/SliderWrapper.svelte';

	interface Props {
		block: ContentCarouselBlock;
	}

	// Component properties
	const { block }: Props = $props();

	// TODO Besides all static dat underneath, make sure that:
	// Add ACF option for alignment of content inside items. Now just statically set to top.
	// The link is optional.

	const staticBlock = {
		items: [
			{
				text: 'We zijn geen heiligen. Maar we proberen het wel beter te doen dan de meeste.',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				},
				link: '/hoe-wij-het-doen'
			},

			{
				text: 'Hoe wij het doen',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				},
				link: '/hoe-wij-het-doen'
			},

			{
				text: 'Steviger, voller, iets rokeriger. Voor wie zijn koffie graag met karakter drinkt. Vanaf nu te bestellen in de webshop. Voor wie zijn koffie graag met karakter drinkt. Vanaf nu te bestellen in de webshop.',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				}
			},

			{
				text: 'Hoe wij het doen',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				}
			},

			{
				text: 'Hoe wij het doen',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				},
				link: '/hoe-wij-het-doen'
			},

			{
				text: 'Hoe wij het doen',
				title: 'We kopen rechtstreeks in van de boer',
				image: {
					url: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=600&h=840&q=80',
					width: 600,
					height: 840,
					alt: 'Foto van een boer die koffie plant'
				},
				link: '/hoe-wij-het-doen'
			}
		]
	};
</script>

<div class="content-carousel">
	{#if block.title || block.subtitle}
		<div class="content-carousel-header">
			{#if block.title}
				<h2 class="content-carousel-title">{block.title}</h2>
			{/if}
			{#if block.subtitle}
				<p class="content-carousel-text">
					{block.subtitle}
				</p>
			{/if}
		</div>
	{/if}

	<div class="content-carousel-slider">
		<SliderWrapper options={{ loop: false, align: 'start', inViewThreshold: 1 }}>
			{#snippet slides(Slide)}
				{#each block.items as item}
					<Slide>
						<div
							class="content-carousel-item"
							class:is-bottom={item.contentAlignment === 'bottom'}
							class:has-link={item.link}
						>
							{#if item.link}
								<a
									href={item.link.url}
									target={item.link.target}
									class="content-carousel-item-link"
									aria-label="Lees meer over {item.title}"
								></a>
								{#if item.contentAlignment !== 'bottom'}
									<div class="content-carousel-item-arrow"></div>
								{/if}
							{/if}
							<div class="content-carousel-item-content">
								<div class="content-carousel-item-info">
									{#if item.text}
										<p class="content-carousel-item-text">
											{item.text}
										</p>
									{/if}
									{#if item.title}
										<h3 class="content-carousel-item-title">
											{item.title}
										</h3>
									{/if}
								</div>
							</div>
							{#if item.image}
								<figure class="content-carousel-item-image">
									<img
										src={item.image.url}
										width={item.image.width}
										height={item.image.height}
										alt={item.image.alt || ''}
										loading="lazy"
										decoding="async"
									/>
								</figure>
							{/if}
						</div>
					</Slide>
				{/each}
			{/snippet}
		</SliderWrapper>
	</div>
</div>

<style lang="postcss" global>
	.content-carousel {
		&-header {
			&:not(:last-child) {
				margin-bottom: var(--spacing-6);
			}
		}

		&-title {
			line-height: 1;
			font-size: 28px;

			&:not(:last-child) {
				margin-bottom: var(--spacing-2);
			}
		}

		&-text {
			font-size: 14px;

			&:not(:last-child) {
				margin-bottom: var(--spacing-2);
			}
		}

		&-slider {
			position: relative;
		}

		.slider,
		.slider-viewport {
			overflow: visible;
		}

		.slider {
			--slide-size: 300px;
		}

		@media (--lg) {
			&-title {
				font-size: 40px;
			}

			&-text {
				font-size: 18px;
			}
		}

		@media (--extra-large) {
			.slider {
				--slide-size: 25%;
			}
		}
	}

	.content-carousel-item {
		& {
			flex: 1;
			display: block;
			position: relative;
			border-radius: var(--radius-5);
			overflow: hidden;
		}

		&-image {
			height: 100%;
			transition: transform var(--transition);

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
				transition: background-color var(--transition);
			}
		}

		&-content {
			position: absolute;
			inset: 16px;
			display: flex;
			flex-direction: column;
			z-index: 1;
		}

		&-info {
			display: flex;
			flex-direction: column;
			gap: 4px;
			padding: 16px;
			border-radius: 8px;
			background-color: rgba(255, 255, 255, 0.8);
		}

		&-text {
			font-family: var(--font-primary);
			font-size: 14px;
			display: -webkit-box;
			-webkit-line-clamp: 6;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}

		&-title {
			font-size: 18px;
			line-height: 1;
		}

		&-link {
			&:before {
				content: '';
				position: absolute;
				inset: 0;
				z-index: 2;
				cursor: pointer;
			}
		}

		&-link:hover + &-arrow {
			background-color: var(--color-primary-dark);
		}

		&-arrow {
			position: absolute;
			bottom: 16px;
			right: 16px;
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: var(--color-white);
			transition: background-color var(--transition);
			border-radius: 8px;

			&:before {
				content: '';
				display: block;
				width: 12px;
				height: 8px;
				background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04IDhMNi45Mzc1IDYuOTM3NUw5LjEyNSA0Ljc1SDBMMCAzLjI1SDkuMTI1TDYuOTM3NSAxLjA2MjVMOCAwTDEyIDRMOCA4WiIgZmlsbD0iIzU5MkUyQyIvPgo8L3N2Zz4K);
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center;
			}
		}

		&.is-bottom &-content {
			align-self: flex-end;
		}

		&.is-bottom &-text {
			order: 2;
		}

		&.is-bottom &-arrow {
			bottom: auto;
			top: 16px;
		}

		&.has-link {
			cursor: pointer;
		}

		&.has-link.is-bottom:hover &-image {
			transform: scale(1.05);
		}

		@media (--lg) {
			&.is-bottom &-text {
				font-size: 16px;
			}

			&-text {
				font-size: 14px;
			}

			&-title {
				font-size: 18px;
			}
		}
	}
</style>
